import { HomeDecisionEntry, fmt } from "@/hooks/useHomeBuyingSim";
import { Sparkles } from "lucide-react";

/**
 * Persistent banner that anchors each screen to the most recent
 * committed home-buying decision and its consequence.
 */
export default function DecisionConsequenceStrip({
  entry,
}: {
  entry: HomeDecisionEntry | null;
}) {
  if (!entry) return null;
  const positive = entry.scoreDelta >= 0;
  const wallet = entry.walletImpact;
  return (
    <div
      className="rounded-2xl border p-3 mb-4 backdrop-blur-md"
      style={{
        borderColor: positive ? "hsl(152 70% 55% / 0.35)" : "hsl(12 88% 60% / 0.35)",
        background: positive ? "hsl(152 70% 55% / 0.08)" : "hsl(12 88% 60% / 0.08)",
      }}
    >
      <div className="flex items-start gap-2">
        <Sparkles
          className="w-4 h-4 mt-0.5 shrink-0"
          style={{ color: positive ? "hsl(152 70% 55%)" : "hsl(12 88% 60%)" }}
        />
        <div className="space-y-1 min-w-0">
          <p className="text-[10px] font-mono uppercase tracking-wider opacity-70">
            {entry.label} · locked in
          </p>
          <p className="text-sm font-semibold text-foreground">{entry.consequence}</p>
          <p className="text-xs text-muted-foreground italic">Lumi: {entry.lumiSignal}</p>
          {wallet !== 0 && (
            <p className="text-[11px] font-mono">
              <span className="opacity-70">Wallet impact: </span>
              <span className={wallet < 0 ? "text-amber-500" : "text-emerald-500"}>
                {wallet < 0 ? "−" : "+"}{fmt(Math.abs(wallet))}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}